import { useLang } from '@/i18n';
import css from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

const Tab2: React.FC = () => {
    const { t } = useLang('stream.overview');

    return (
        <div className={`${css.frag}`}>
            <EcoImg
                className="tab2-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1774595445374/h2.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1774595445374/h2.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1774595445836/h2m.jpg"
                alt={t('H_item2_name')}
            />
            <div className="img-info">
                <p className="name">{t('H_item2_name')}</p>
                <p className="text">
                    {t.rich('H_item2_text', {
                        w: (tx: string) => <span className="w">{tx}</span>,
                    })}
                </p>
            </div>
        </div>
    );
};

export default Tab2;
